import { motion } from "framer-motion";
import { BadgeCheck, FileText, ShieldCheck, Landmark } from "lucide-react";

const badges = [
  { icon: Landmark, label: "Registered on GeM", note: "Government e-Marketplace vendor" },
  { icon: BadgeCheck, label: "MSME Registered", note: "Recognised Micro, Small & Medium Enterprise" },
  { icon: ShieldCheck, label: "Quality Commitment", note: "Inspection and traceability protocols" },
  { icon: FileText, label: "Transparent Operations", note: "Clear scoping, pricing and reporting" },
];

export default function Trust() {
  return (
    <section
      id="trust"
      data-testid="trust-section"
      className="relative bg-[var(--nv-paper)] text-[var(--nv-navy)] py-28 md:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-6 items-end mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-7">
            <div className="overline text-[var(--nv-gold)] flex items-center gap-3">
              <span className="inline-block w-6 h-px bg-[var(--nv-gold)]" />
              <span>Trust & Business Credentials</span>
            </div>
            <h2 className="mt-6 display text-5xl md:text-7xl" data-testid="trust-heading">
              Credentials that <span className="italic text-[var(--nv-gold)]">travel.</span>
            </h2>
          </div>
          <p className="col-span-12 md:col-span-4 md:col-start-9 text-[15px] leading-relaxed text-[var(--nv-navy)]/70">
            Trust markers that matter to procurement teams — for both government and private-sector buyers.
          </p>
        </div>

        <div className="grid grid-cols-12 gap-4 md:gap-6" data-testid="trust-grid">
          {badges.map((b, i) => {
            const Icon = b.icon;
            return (
              <motion.div
                key={b.label}
                initial={{ opacity: 0, y: 22 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.7, ease: [0.7, 0, 0.3, 1], delay: i * 0.06 }}
                className="col-span-12 md:col-span-6 lg:col-span-3 group relative border border-[var(--nv-line)] p-8 bg-white hover:border-[var(--nv-navy)] transition-[border-color,transform] duration-500 hover:-translate-y-1"
                data-testid={`trust-badge-${i}`}
              >
                <span className="inline-flex items-center justify-center w-12 h-12 rounded-full border border-[var(--nv-navy)]/30 group-hover:border-[var(--nv-gold)] transition-colors duration-500">
                  <Icon className="w-5 h-5" />
                </span>
                <h3 className="mt-8 font-serif text-xl md:text-2xl tracking-tight leading-[1.15]">{b.label}</h3>
                <p className="mt-3 text-sm leading-relaxed text-[var(--nv-navy)]/70">{b.note}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
